import * as React from 'react';
import { useField, useFormikContext } from 'formik';
import { formatMessage } from '../../translations/format-message';
import { useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput, { isValidPhoneNumber, formatPhoneNumber, getCountryCallingCode, Country, parsePhoneNumber } from 'react-phone-number-input';
import en from 'react-phone-number-input/locale/en.json'
import it from 'react-phone-number-input/locale/it.json'
import ja from 'react-phone-number-input/locale/ja.json'

export default function FormikPhoneInput(props:any) {
  const [ field, meta, helpers ] = useField(props);
  const { touched, error } = meta;
  const [inputValue, setInputValue] = useState<string>();
  const [focused, setFocused] = React.useState(false);

  return (
    <>
        <PhoneInput
            className="form-control"
            // international={false}
            addInternationalOption={false}
            value={inputValue}
            onChange={(val) => {
                helpers.setValue(val)
            }}
            initialValueFormat="national"            
            placeholder={props.placeholder}
            // defaultCountry='IN'
            countryCallingCodeEditable={false}
        />
    { 
        (error && <span data-testid="testError" className=" text-danger errorMessage">{formatMessage(error)}</span>)
        // (dateError && <span data-testid="testError" className=" text-danger errorMessage">{formatMessage(dateError)}</span>)
    }
    </>
  );
}